import { FunctionComponent } from "react";
import "./HeaderLogin.css";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../../icons/Logo-white.svg';

export type HeaderType = {
  className?: string;
};
const Header: FunctionComponent<HeaderType> = ({ className = "" }) => {
  const handleClick = () => {
    window.location.href = '/';
  };
  return (
    
    <header className="header">
      <a href="/">
        <img
          className="logo"
          loading="lazy"
          alt=""
          src={logo}
        />
      </a>

      <Navbar expand="lg" style={{ backgroundColor: 'transparent', justifyContent: 'center'}}>
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            {/* <Nav className="me-auto">
                <Nav.Item className="button" onClick={handleClick}>Home</Nav.Item>
            </Nav> */}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;